<template>
	<li v-for="i in validProsthesisCount" :key="i" class="aiProContBox">
		<div class="aiProTop">
			<div class="num">NO.{{ i }}</div>
			<div class="form-group remake_cont">
				<label class="form-label">리메이크</label>
				<p class="form-control">
					<span :id="'remake_' + i" class="proStatus"
						:class="orderJsonData[`remake_${i}`] ? (orderJsonData[`remake_${i}`] === 'remake' ? 'yes' : 'no') : 'no'">{{ orderJsonData[`remake_${i}`] ? (orderJsonData[`remake_${i}`] === 'remake' ? 'Y' : 'no') : 'N' }}</span>
				</p>
			</div>
		</div>

		<table class="ai_order_table">
			<tbody>
				<tr>
					<th>의뢰보철물</th>
					<td>
						<p class="form-control" :id="'options_' + i">{{ orderJsonData[`options_${i}`] }} + {{ orderJsonData[`detail_${i}`] }}</p>
					</td>
				</tr>
				<tr>
					<th>치식</th>
					<td>
						<div class="teethWrap">
							<div class="teeth">
								<div class="r_teeth r_teeth1">
									<div v-for="(value, idx) in [18, 17, 16, 15, 14, 13, 12, 11]" :key="value"
										:id="'r_teeth_check' + value + '_' + 1" :data-idx="idx"
										:class="{ 'active': isActive(i, value) }">
										{{ value }}
									</div>
								</div>
								<div class="r_teeth r_teeth2">
									<div v-for="(value, idx) in [21, 22, 23, 24, 25, 26, 27, 28]" :key="value"
										:id="'r_teeth_check' + value + '_' + 2" :data-idx="idx"
										:class="{ 'active': isActive(i, value) }">
										{{ value }}
									</div>
								</div>
								<div class="r_teeth r_teeth3">
									<div v-for="(value, idx) in [48, 47, 46, 45, 44, 43, 42, 41]" :key="value"
										:id="'r_teeth_check' + value + '_' + 3" :data-idx="idx"
										:class="{ 'active': isActive(i, value) }">
										{{ value }}
									</div>
								</div>
								<div class="r_teeth r_teeth4">
									<div v-for="(value, idx) in [31, 32, 33, 34, 35, 36, 37, 38]" :key="value"
										:id="'r_teeth_check' + value + '_' + 4" :data-idx="idx"
										:class="{ 'active': isActive(i, value) }">
										{{ value }}
									</div>
								</div>
							</div>
						</div>
					</td>
				</tr>
				<tr>
					<th>메모</th>
					<td>
						<p :id="'memo_' + i" class="proMemo" v-html="typeof orderJsonData[`memo_${i}`] === 'string' 
							? commonjs.replaceToBr(orderJsonData[`memo_${i}`]) 
							: commonjs.replaceToBr(orderJsonData[`memo_${i}`].join(''))">
						</p>
					</td>
				</tr>
			</tbody>
		</table>
	</li>
</template>

<script setup>
import { env as SERVER_URL } from '@/components/utils/env';
import { onMounted, ref, computed, watch } from 'vue';
import * as globaljs from '@/components/utils/global';
import * as aiorderjs from '@/components/utils/aiorder';
import * as commonjs from '@/components/utils/common';

const props = defineProps(['orderJsonData']);

const validProsthesisCount = computed(() => {
	const count = parseInt(props.orderJsonData.prosthesis_cnt, 10);
	return isNaN(count) || count <= 0 ? 0 : count;
});

const teethArray = (index) => {
	const teethData = props.orderJsonData[`teeth_${index}`];
	if (!teethData || !teethData[0]) {
		return [];
	}
	return teethData[0].split(',').map(item => parseInt(item.trim(), 10));
};

const isActive = (index, value) => {
	return teethArray(index).includes(value);
};
</script>